import { render, staticRenderFns } from "./PoliticasView.vue?vue&type=template&id=5cb69424"
import script from "./PoliticasView.vue?vue&type=script&lang=ts"
export * from "./PoliticasView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports